/**
 * 客户区域分布转成交统计 - 到店客户
 */
export default {
  field_from_api: {
    arrived: {
      name: '到店量(客流)',
      is_rate: false
    },
    arrived_rate: {
      name: '到店量(客流)占比',
      is_rate: true
    },
    deal: {
      name: '成交台数',
      is_rate: false
    },
    deal_total_rate: {
      name: '成交台数占比',
      is_rate: true
    },
    deal_rate: {
      name: '成交率',
      is_rate: true
    }
  },
  getData (params = {}) {
    this.$rest.dataAnalysis.getCustomerArea(params).then(res => {
      if (res.code === 0) {
        this.dataList = res.data
      } else {
        this.showToast(res.message)
      }
    })
  }
}
